import React from 'react';
import styledC from 'styled-components';
import Checkbox from '@adsk/alloy-react-checkbox';
import theme from '@adsk/alloy-react-theme';
const StyledLabel = styledC.label.withConfig({
  displayName: "FooterOption__StyledLabel",
  componentId: "sc-1lh8fuo-0"
})(["", " display:flex;margin-right:8px;color:", ";"], theme.typography.labelSmall, theme.tokens.colors.text.primary.value);
const FooterOption = _ref => {
  let {
    label,
    defaultChecked,
    onChange
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledLabel, null, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: onChange,
    defaultChecked: defaultChecked,
    style: {
      marginRight: 8
    }
  }), label);
};
export default FooterOption;
//# sourceMappingURL=FooterOption.js.map